/**
 * Created by adam.clarke on 21/10/2016.
 */
admin.registerLoad(function (prefix) {
    $(prefix + '.js-user-confirm').click(function (ev) {
        ev.preventDefault();

        // trigger ajax action for toggling the user as confirmed
        var url = $(this).data('url');
        var tr = $(this).closest("tr");
        var td = tr.find("td.identifier_confirmed");
        td.html("<span class='please-wait-loading badge badge-success'>Saving...</span>");

        $(this).remove();

        $.ajax({
            url: url,
            dataType: 'json',
        }).done(function() {
            td.html('<span class="checked"><i class="fa fa-check"></i></span>');
        }).error(function(response) {
            td.html(response.responseJSON.errors[0].message);
        });
    });

    $(prefix + ".js-password-reset").click(function (ev) {

        ev.preventDefault();

        var url = $(this).attr('href');

        $.ajax({
            url: url,
            dataType: 'json',
        }).done(function() {

            swal({
                title: "Password reset send to user",
                text: "",
                type: "success",
                showCancelButton: false,
                confirmButtonColor: "#1ab394",
                confirmButtonText: "OK!",
                closeOnConfirm: false,
                timer: 5000,
            });

        }).error(function(response) {

            alert(response);

        });
    });

    $(prefix + '.js-convert-additional-rider').click(function (ev) {
        ev.preventDefault();

        var button = $(this);
        var row = $(this).closest("tr");
        var email = row.find(".identifier_email").text().trim();

        swal({
                title: "Convert to Full User",
                text: "This will make an additional rider user into a full user. The user will need a unique email that is not in use by any other full users.",
                type: "input",
                showCancelButton: true,
                animation: "slide-from-top",
                inputPlaceholder: "Email Address",
                inputValue: email
            },
            function(inputValue){
                if (inputValue === false) return false;

                // make call with new email and check result

                var url = button.data('converturl');
                url = url + "?email=" + encodeURIComponent(inputValue);

                $.ajax({
                    url: url,
                    dataType: 'json',
                    success: function(data) {
                        row.find(".identifier_email").html(data.email);
                        row.find(".identifier_additional_rider").html(data.flag);

                        if (data.errors.length > 0)
                        {
                            var error_text = "";
                            for (var i = 0 ; i < data.errors.length ; i++)
                            {
                                error_text += data.errors[i].message + "\n";
                            }

                            swal({
                                title: "Unable to Convert to Full User",
                                text: error_text,
                                type: "error"
                            });
                        } else {
                            row.find(".js-convert-additional-rider").remove();
                        }
                    }
                });
            });
    });

    $(prefix + '.js-swap-main-user').click(function (ev) {
        ev.preventDefault();

        var button = $(this);

        swal({
                title: "Swap Full User",
                text: "Convert this user into a full user. The existing non additional rider user with a matching email address will be converted to an additional rider.",
                showCancelButton: true,
                animation: "slide-from-top",
            },
            function(){

                var url = button.data('swapurl');

                $.ajax({
                    url: url,
                    dataType: 'json',
                    success: function(data) {
                        if (data.errors.length > 0)
                        {
                            var error_text = "";
                            for (var i = 0 ; i < data.errors.length ; i++)
                            {
                                error_text += data.errors[i].message + "\n";
                            }

                            swal({
                                title: "Unable to Swap Full User",
                                text: error_text,
                                type: "error"
                            });
                        } else {
                            $('.js-filter-submit').click();
                        }
                    }
                });
            });
    });
});
